import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import React, { useContext } from 'react';
import useMount from "react-use/lib/useMount";
import axios from 'axios';
import { logout as _logout, getItem, setData } from './storage';
import { emailLogin, facebookLogin, googleLogin, emailSignup } from './api';
import { useConfig } from '../config';

var defaultFn = function defaultFn() {
  throw new Error('AuthContext not initialized');
};

export var AuthContext = React.createContext({
  loggedIn: false,
  user: null,
  access_token: null,
  login: defaultFn,
  signup: defaultFn,
  logout: defaultFn,
  facebookLogin: defaultFn,
  googleLogin: defaultFn,
  setAccessToken: defaultFn
});
export var AuthProvider = function AuthProvider(_ref) {
  var apiBaseUrl = _ref.apiBaseUrl,
      children = _ref.children;

  var _React$useState = React.useState(getItem('access_token') || null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      accessToken = _React$useState2[0],
      _setAccessToken = _React$useState2[1];

  var _React$useState3 = React.useState(getItem('user') || null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      user = _React$useState4[0],
      setUser = _React$useState4[1];

  var userOut = React.useMemo(function () {
    if (user) {
      return Object.assign(Object.assign({}, user), {
        isPaidMember: user.paymentStoreType !== 0 && user.displayExpirationTimeStamp !== 0
      });
    }

    return user;
  }, [user]);
  var config = useConfig();
  useMount(function () {
    if (accessToken) {
      axios({
        method: 'get',
        url: "".concat(apiBaseUrl, "/v2/user/profile?includeOneTimeProducts=true"),
        headers: {
          Authorization: "Bearer ".concat(accessToken)
        }
      }).then(function (result) {
        var _a, _b;

        if ((_b = (_a = result) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.result) {
          setUser(result.data.result);
          setData({
            user: result.data.result
          });
        }
      }).catch(function () {});
    }
  });
  var authData = React.useMemo(function () {
    console.log("Auth data constructed");
    return {
      access_token: accessToken,
      user: userOut,
      loggedIn: !!userOut,
      login: emailLogin(_setAccessToken, setUser, config),
      signup: emailSignup(_setAccessToken, setUser, config),
      logout: function logout() {
        return __awaiter(void 0, void 0, void 0, function* () {
          _setAccessToken(null);

          setUser(null);
          return _logout();
        });
      },
      facebookLogin: facebookLogin(_setAccessToken, setUser, config),
      googleLogin: googleLogin(_setAccessToken, setUser, config),
      setAccessToken: function setAccessToken(accessToken) {
        return __awaiter(void 0, void 0, void 0, function* () {
          var _a, _b;

          var result = yield axios({
            method: 'get',
            url: "".concat(apiBaseUrl, "/v2/user/profile?includeOneTimeProducts=true"),
            headers: {
              Authorization: "Bearer ".concat(accessToken)
            }
          });

          if ((_b = (_a = result) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.result) {
            _setAccessToken(accessToken);

            setUser(result.data.result);
            setData({
              access_token: accessToken,
              user: result.data.result
            });
            return result.data.result;
          }
        });
      }
    };
  }, [accessToken, userOut, _setAccessToken, setUser, config, _logout, emailLogin, emailSignup, facebookLogin, googleLogin]);
  console.log(authData);
  return React.createElement(AuthContext.Provider, {
    value: authData
  }, children);
};
export var useAuthContext = function useAuthContext() {
  return useContext(AuthContext);
};
export var useIsLoggedIn = function useIsLoggedIn() {
  return useAuthContext().loggedIn;
};